import { Switch } from "@progress/kendo-react-inputs"
import React from "react"
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks"
import { editCaseManDocumentRequest } from "../../../../../services/caseManService/model/caseMan/CaseManagementSlice";
import { ReduxUpdate } from "../../../../../utils/ReduxUpdateCommands";

function PathologyRequest(){
    const dispatch = useAppDispatch();
    const caseMan = useAppSelector((state) => state.caseManagement.caseManagement);

    return <React.Fragment>
        <div>
            <label>Pathology Report</label><br/>
            <Switch value={caseMan.documentRequest?.pathologyReport}
                checked={caseMan.documentRequest?.pathologyReport}
                onChange={(e)=>dispatch(editCaseManDocumentRequest(new ReduxUpdate('pathologyReport',e.target.value)))}/>
        </div>
    </React.Fragment>
}
export {PathologyRequest}